
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cOKrX", function(module, exports) {
$parcel$export(module.exports, "canCompress", () => (parcelRequire("ekuJ0")).canCompress);
$parcel$export(module.exports, "buildCompressionFunction", () => (parcelRequire("ekuJ0")).buildCompressionFunction);

var $ekuJ0 = parcelRequire("ekuJ0");


});

parcelRegister("ekuJ0", function(module, exports) {
const $8628cb6d86737b0e$export$ec3662f84d9f778c = (event)=>event.actionSubject === 'feature' && event.action === 'exposed' && event.eventType === 'operational' && event.attributes && event.tags && event.tags.includes('measurement') && !event.tags.includes('hasCustomAttributes');
const $8628cb6d86737b0e$export$ca25d5d7792a4f37 = (events, batchSize = 50)=>{
    if (!events || events.length <= 0) return [];
    if (batchSize <= 0) throw new Error('Batch size must be greater than 0');
    // Extract evaluations and reduce into a single array
    const flagEvaluations = events.map((currentEvent)=>{
        const { flagKey: flagKey, value: value, reason: reason, ruleId: ruleId, errorKind: errorKind } = currentEvent.attributes;
        return {
            key: flagKey,
            value: value,
            ...reason && {
                reason: reason
            },
            ...ruleId && {
                ruleId: ruleId
            },
            ...errorKind && {
                errorKind: errorKind
            }
        };
    });
    // Batch evaluations into specified batchSize
    return $8628cb6d86737b0e$var$createBatches(flagEvaluations, batchSize);
};
const $8628cb6d86737b0e$var$createBatches = (array, batchSize)=>{
    let compressedEvaluations = [];
    for(let i = 0; i < array.length; i += batchSize){
        let evaluationBatch = array.slice(i, i + batchSize);
        compressedEvaluations.push({
            actionSubject: 'features',
            action: 'exposed',
            eventType: 'operational',
            attributes: {
                evaluations: evaluationBatch
            },
            tags: [
                'measurement'
            ],
            source: '@atlassian/exposure-events-compressor'
        });
    }
    return compressedEvaluations;
};
const $8628cb6d86737b0e$export$20de0576abb0bcc5 = (batchSize)=>(events)=>$8628cb6d86737b0e$export$ca25d5d7792a4f37(events, batchSize);
module.exports["canCompress"] = $8628cb6d86737b0e$export$ec3662f84d9f778c;
module.exports["buildCompressionFunction"] = $8628cb6d86737b0e$export$20de0576abb0bcc5;

});


//# sourceMappingURL=exposure-events-compressor.51ea75bd.js.map
